import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import classNames from 'classnames';

import AmazonLogo from '../SvgImages/AmazonLogo';
import IkeaLogo from '../SvgImages/IkeaLogo';
import PlaystationLogo from '../SvgImages/PlaystationLogo';
import ZalandoLogo from '../SvgImages/ZalandoLogo';

import styles from './BrandsBanner.module.scss';

const BrandsBanner = ({
  className = '',
  rounded = false,
  centered = false,
  layout = 'column'
}) => {
  const classes = classNames(
    styles['referral-brands-banner__container'],
    className,
    {
      [styles['referral-brands-banner__container--rounded']]: rounded,
      [styles['referral-brands-banner__container--centered']]: centered,
      [styles['referral-brands-banner__container--row']]: layout === 'row'
    }
  );

  const iconsClasses = classNames(styles['referral-brands-banner__icons'], {
    [styles['referral-brands-banner__icons--centered']]: centered,
    [styles['referral-brands-banner__icons--row']]: layout === 'row'
  });

  return (
    <div className={classes}>
      <p className={styles['referral-brands-banner__text']}>
        {trans('my-referrals.banner.code.valid.shops')}
      </p>
      <div className={iconsClasses}>
        <IkeaLogo />
        <PlaystationLogo />
        <AmazonLogo />
        <ZalandoLogo />
      </div>
    </div>
  );
};

BrandsBanner.propTypes = {
  className: PropTypes.string,
  rounded: PropTypes.bool,
  centered: PropTypes.bool,
  layout: PropTypes.oneOf(['column', 'row'])
};

export default BrandsBanner;
